import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { SpacerProps } from "./types";

function Spacer({
  size = "h-4",
  direction = "vertical",
  className,
  ...props
}: SpacerProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <div
      id="SPACER"
      className={cn(
        direction === "vertical" ? size : size.replace("h-", "w-"),
        className,
        classes,
      )}
      aria-hidden="true"
      {...native}
    />
  );
}

export default Spacer;
